export enum PartnerRelationshipTypeEnum {
    Distributor = 'Distributor',
    LoanServicer = 'LoanServicer'
}
